import { Mail, Clock, Sparkles, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { BRAND, IMAGES } from "@/lib/constants";
import WaitlistForm from "@/components/WaitlistForm";

export default function Menu() {
  return (
    <div data-testid="menu-page">
      {/* COMING SOON HERO */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 -z-10">
          <div className="absolute inset-0 bg-[#0A0B0E]" />
          <img
            src={IMAGES.heroAbstract}
            alt=""
            aria-hidden="true"
            className="absolute inset-0 w-full h-full object-cover opacity-30"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0A0B0E]/60 via-[#0A0B0E]/80 to-[#0A0B0E]" />
          <div className="absolute inset-0 grid-noise opacity-40" />
        </div>
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14 pt-20 md:pt-36 pb-14 md:pb-28">
          <div className="grid grid-cols-12 gap-6 md:gap-10 items-center">
            <div className="col-span-12 lg:col-span-7 min-w-0 animate-fade-up">
              <div className="inline-flex items-center gap-2 rounded-full border border-[#28C0D8]/30 bg-[#28C0D8]/5 px-4 py-1.5 text-xs font-medium tracking-wide text-[#28C0D8]">
                <Sparkles className="h-3 w-3" />
                Shop · Coming Soon
              </div>
              <h1 className="mt-6 font-display text-[32px] sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.05] text-white break-words">
                MD Supply Wellness Shop is{" "}
                <span className="text-[#28C0D8]">coming soon.</span>
              </h1>
              <p className="mt-6 max-w-xl text-base md:text-lg leading-relaxed text-[#94A3B8] break-words">
                We&apos;re putting the finishing touches on our online wellness
                and medical cannabis shop. Our goal is to launch soon with a
                seamless, trusted shopping experience for all your care needs.
              </p>

              <div className="mt-8 md:mt-10">
                <WaitlistForm source="menu_coming_soon" />
              </div>
            </div>

            <div className="col-span-12 lg:col-span-5 min-w-0 animate-fade-up [animation-delay:120ms]">
              <div className="relative aspect-square rounded-3xl overflow-hidden border border-white/10 shadow-[0_30px_80px_-30px_rgba(40,192,216,0.35)]">
                <img
                  src={IMAGES.macro2}
                  alt="Cannabis wellness"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A0B0E] via-[#0A0B0E]/30 to-transparent" />
                <div className="absolute bottom-0 inset-x-0 p-7">
                  <p className="text-xs uppercase tracking-[0.22em] text-[#28C0D8]">
                    Finalizing inventory
                  </p>
                  <p className="mt-2 font-display text-xl font-semibold text-white leading-snug">
                    Flower · Vapes · Edibles · Tinctures · Concentrates ·
                    Topicals
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* LAUNCH INFO */}
      <section className="py-20 md:py-28 border-t border-white/5">
        <div className="max-w-[1100px] mx-auto px-6 md:px-10 lg:px-14 text-center">
          <Clock className="h-10 w-10 text-[#28C0D8] mx-auto mb-6" />
          <h2 className="font-display text-3xl md:text-4xl font-semibold text-white tracking-tight">
            We&apos;re almost ready.
          </h2>
          <p className="mt-5 text-[17px] leading-relaxed text-[#94A3B8]">
            We are currently finalizing inventory, compliance standards, and
            product selection to ensure a safe, reliable, and high-quality
            shopping experience. We will officially launch soon in Bethesda,
            Maryland.
          </p>
        </div>
      </section>

      {/* CAREERS TEASER */}
      <section
        className="py-14 md:py-24 bg-[#0A0B0E] border-t border-white/5"
        id="careers"
        data-testid="careers-teaser-section"
      >
        <div className="max-w-[1100px] mx-auto px-6 md:px-10 lg:px-14 text-center">
          <p className="text-xs uppercase tracking-[0.22em] text-[#28C0D8] font-semibold">
            Now Hiring
          </p>
          <h2 className="mt-3 font-display text-3xl md:text-4xl font-semibold tracking-tight text-white max-w-2xl mx-auto">
            Help us build Bethesda&apos;s most trusted dispensary.
          </h2>
          <p className="mt-4 text-[15px] text-[#94A3B8] max-w-xl mx-auto">
            We&apos;re hiring for Compliance Manager, AM &amp; PM Supervisors,
            and Budtender roles. Apply in two minutes.
          </p>
          <div className="mt-8 flex flex-col items-center sm:flex-row gap-3 justify-center">
            <Link
              to="/careers#apply"
              className="btn-teal-glow inline-flex items-center gap-2 rounded-full bg-[#28C0D8] px-5 py-3 text-sm md:px-6 md:py-3.5 md:text-[15px] font-semibold text-[#0A0B0E] hover:bg-[#1FA8BC]"
              data-testid="menu-apply-btn"
            >
              Apply Now <ArrowRight className="h-4 w-4" />
            </Link>
            <Link
              to="/careers"
              className="inline-flex items-center gap-2 rounded-full border border-white/15 px-5 py-3 text-sm md:px-6 md:py-3.5 md:text-[15px] font-medium text-white hover:bg-white/5"
            >
              See all positions
            </Link>
          </div>
        </div>
      </section>

      {/* CTA BAND */}
      <section className="border-t border-white/5 bg-[#0A0B0E]">
        <div className="max-w-[1100px] mx-auto px-6 md:px-10 lg:px-14 py-20 text-center">
          <h3 className="font-display text-3xl md:text-4xl font-semibold text-white tracking-tight">
            Want early access?
          </h3>
          <p className="mt-4 text-[#94A3B8]">
            Join our waitlist and be first in line on launch day.
          </p>
          <div className="mt-8 flex justify-center">
            <WaitlistForm source="menu_cta" />
          </div>
          <a
            href={`mailto:${BRAND.email}`}
            className="mt-8 inline-flex items-center gap-2 text-[#28C0D8] hover:gap-3 transition-all text-sm font-medium"
          >
            Or say hello: {BRAND.email} <ArrowRight className="h-4 w-4" />
          </a>
        </div>
      </section>
    </div>
  );
}
